import React from 'react';
import '../style/newstyle.css';

function KnowledgeManagement() {
    return (
        <div class="wrapper">
            <header class="site-header">
                <div class="container">
                    <div class="row">
                        <div class="logo">
                            <a href="/"><img src={require('../style/img/header-logo.png')} alt="Condor Green Logo" /></a>
                            <button class="mobile-toggle" onClick={() => this.onSetSidebarOpen(true)}>Menu</button>
                        </div>
                        <div class="header-right">
                            <nav class="menu-bar">
                                <ul>
                                    {/* <li><a href="#">Case Studies</a></li> */}
                                    <li><a href="#">Register/Demo</a></li>
                                    <li><a href="mailto:sales@condor360.online">Contact Sales</a></li>
                                    <li><a href="mailto:support@condor360.online">Support</a></li>
                                    <li><a href="#">Sign In <img src={require('../style/img/login-icon.png')} alt="login" /></a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
            <section class="inner-section">
                <div class="container">
                    <h2 class="section-heading">Knowledge <strong>Management</strong></h2>
                    <div class="watermark-box">
                        <div class="content-wrap">
                            <p>Timesheet analysis can be positively used to help grow Users. It is vital that companies use Resource management in a positive way that benefits the Client, User and Service Provider. Understanding the Service and the Clients needs are therefore paramount.</p>
                            <p>MONITOR, MEASURE and MANAGE is a Methodology that should be adopted for almost any Service.</p>
                            <p>Service Baselines can be determined, by knowing the length of time various Activities needs. This helps to maintain Service agreements with clients.</p>
                            <p>Timesheets can be used to analyse a service, and identify key areas where competency is vital. A Users experience with any service depends on the Users work exposure. Competency across a Service many not be balanced and timesheet analysis can identify areas that needs re-enforcing.</p>
                            <p>Timesheet analysis can be used to determine key components of a service.</p>
                            <p>The length of time a User spends on a Service relates to the Users experience and skill. Timesheet analyses can be used positively to hone in on Users that may need more training and mentoring. </p>
                        </div>
                    </div>
                </div>
            </section>
            <div class="sub-footer">
                <div class="row d-flex">
                    <div class="col-6">
                        <h3><span>Want</span> To Learn More ?</h3>
                        <p>The First Draft Is Written and Reviewed to Create</p>
                    </div>
                    <div class="col-4">
                        <div class="text-right">
                            <a href="#" class="default-btn prime-btn">Contact Us Today</a>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="main-footer">
                <div class="container">
                    <div class="row d-flex">
                        <div class="col-3">
                            <div class="foot-widget f-widget-1">
                                <div class="let-talk-btn"><a href="#">LET’S TALK! <img src="images/foot-arrow.jpg" alt="" /></a></div>
                                <p>There is no better time than now</p>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="foot-widget  f-widget-2">
                                <h4 class="title">Address</h4>
                                <p>4th Floor, West Tower, Canal Walk, Century City, Cape Town, 7435<br></br>South Africa</p>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="foot-widget f-widget-3">
                                <h4 class="title">Contact Detail</h4>
                                <p>Phone: (+27) 21 555 2013</p>
                                <p>Email: sales@condor360.online </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="copyright">
                    <div class="container">
                        <p>&copy; Copyright 2020 Condogreen Infotech | All Rghts Reserved</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}
export default KnowledgeManagement